export enum PetScreeningStatus {
  // completed & approved
  active = "active",
  // Assistance‑animal approvals
  recommended = "recommended",
  conditionally_recommended = "conditionally_recommended",
  // Mid‑review states
  draft = "draft",
  verifying = "verifying",
  non_responsive = "non_responsive",
  // Not approved
  declined = "declined",
  expired = "expired",
  returned = "returned",
  // Assistance pending review
  pending = "pending"
}

export interface PetScreeningAnimal {
  id: string;
  name: string;
  species: string;
  created_at: string;
  type?: "household" | "assistance" | "not_pet";
  status: PetScreeningStatus;
  fido_score?: number;
  dominant_breed?: string;
  secondary_breed?: string;
  sex?: string;
  neutered_spayed?: boolean;
  birth_date?: string;
  date_of_ownership?: string;
  weight?: {
    value?: number;
    unit?: string;
  };
  coat_colors?: string[];
  is_service_animal?: boolean;
  is_vaccinated?: boolean;
  vaccination?: Vaccine[];
}

export type Vaccine = {
  vaccination_date?: string;
  expiration_date?: string;
  type?: string;
};
